import script from "./VTableCredit.vue?vue&type=script&setup=true&lang=js"
export * from "./VTableCredit.vue?vue&type=script&setup=true&lang=js"

import "./VTableCredit.vue?vue&type=style&index=0&id=097e638c&scoped=true&lang=less"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-097e638c"]])

export default __exports__